import axios from 'axios';
import {
	ENDPOINT_URL,
	GROUP_DASHBOARD_STATS_API,
	HOME_DASHBOARD_STATS_API,
} from '../../../constants/commonConstants';
import {decodeAgentResponse} from '../../core/resolutionUtils';

/**
 * Read a whole number from an API value.
 * @param {*} value API value
 * @return {number} count
 */
function count(value) {
	const parsed = Number(value);
	return Number.isFinite(parsed) ? parsed : 0;
}

/**
 * Report how many Access Points are online and offline.
 *
 * Canvas already counts these for the dashboards, so they are read from there
 * rather than tallied from a lookup - a page of results would undercount every
 * tenant with more Access Points than one page holds.
 * @param {object} command read_statistic command
 * @return {Promise<{values: {online: number, offline: number}}>} counts
 */
export async function readAccessPointStatusCounts(command = {}) {
	const siteId = command.params?.site_id;
	const url = siteId
		? `${ENDPOINT_URL}${GROUP_DASHBOARD_STATS_API}${encodeURIComponent(siteId)}/`
		: `${ENDPOINT_URL}${HOME_DASHBOARD_STATS_API}`;
	const {data} = await axios.get(url);
	const document = decodeAgentResponse(data) || {};
	const stats = document?.data ?? document;
	if (siteId) {
		return {
			values: {
				online: count(stats?.online),
				offline: count(stats?.offline),
			},
		};
	}
	const rows = Array.isArray(stats?.ap_online_offline)
		? stats.ap_online_offline
		: [];
	const forState = (connected) => count(
		rows.find((row) => Number(row?.is_connected) === connected)?.count,
	);
	return {values: {online: forState(1), offline: forState(0)}};
}
